import { gql } from '@apollo/client';

export const getBPVignetteRangeList = gql`
  query getBusinessPartnerVignetteRangeList(
    $pagination: PaginationInput!
    $selectedBusinessPartnerID: String!
    $Attribute: String!
    $Descending: Boolean!
    $keywordSearch: String
  ) {
    SalesforceManagement {
      queries {
        getBusinessPartnerVignetteRange(
          pagination: $pagination
          selectedBusinessPartnerID: $selectedBusinessPartnerID
          OrderBy: { Attribute: $Attribute, Descending: $Descending }
          KeywordSearch: $keywordSearch
        ) {
          paging {
            pageSize
            pageNumber
            totalCount
          }
          items {
            salesforceManagement_BusinessPartnerVignetteRange_Id
            salesforceManagement_BusinessPartnerVignetteRange_BusinessPartnerID {
              id
            }
            salesforceManagement_BusinessPartnerVignetteRange_createdOn
            salesforceManagement_BusinessPartnerVignetteRange_createdBy
            salesforceManagement_BusinessPartnerVignetteRange_modifiedOn
            salesforceManagement_BusinessPartnerVignetteRange_modifiedBy
            salesforceManagement_BusinessPartnerVignetteRange_RangeFrom
            salesforceManagement_BusinessPartnerVignetteRange_RangeTo
            salesforceManagement_BusinessPartnerVignetteRange_RangeStatus
            salesforceManagement_BusinessPartnerVignetteRange_RangeYear
            salesforceManagement_BusinessPartnerVignetteRange_RangeCode
          }
        }
      }
    }
  }
`;
